import {Component, Input, OnInit} from '@angular/core';
import {LimitSessionsService} from '../../../../services/limit-sessions/limit-sessions.service';
import {IUser} from '../../../../core/interfaces/user';
import moment from 'moment';
import {FirebaseService} from '../../../../services/firebase/firebase.service';
import {take} from 'rxjs/operators';

@Component({
  selector: 'kt-month-limit',
  templateUrl: './month-limit.component.html',
  styleUrls: ['./month-limit.component.scss']
})
export class MonthLimitComponent implements OnInit {
  @Input() currentUser: IUser;
  constructor(
    private monthSessions: LimitSessionsService,
    private firebase: FirebaseService
  ) { }

  ngOnInit(): void {
    this.calculateUserLimit();
  }
  calculateUserLimit() {
    this.monthSessions.calculateUserMontLimit(this.currentUser).pipe(take(1)).subscribe((updatedUser) => {
      this.currentUser = updatedUser;
      this.firebase.updateUser(this.currentUser.uid, this.currentUser);
    });
  }
  convertHoursToHHMM(hours) {
    const duration = moment.duration(hours, 'hours');
    return moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
  }
  convertMonthTime(time) {
    return this.monthSessions.secondsToHHMMSS(time);
  }
}
